import React from "react";
import PropTypes from "prop-types";

export const CheckBoxLabelSize = {
    Big: "big",
    Medium: "", //default size
    Small: "small"
};

const CheckboxButton = (props) => {
    return (
        <button
            className={"btn btn-chkb " + props.labelSize + " " + props.classes}
            type="button"
            data-toggle="button"
            aria-pressed={props.checked}
            disabled={props.disabled}
            onClick={() => props.onClick ? props.onClick(!props.checked) : null}
        >
            {props.label && <span>{props.label}</span>}
            {props.labelArray && <span>{props.labelArray}</span>}
        </button>
    );
}

CheckboxButton.defaultProps = {
    disabled: false,
    checked: false,
    labelSize: CheckBoxLabelSize.Medium,
    classes: "",
    label: "",
    labelArray: null
}

CheckboxButton.propTypes = {
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    label: PropTypes.string,
    labelArray: PropTypes.array, //text + link
    labelSize: PropTypes.oneOf(Object.values(CheckBoxLabelSize)),
    onClick: PropTypes.func,
    classes: PropTypes.string
};

export default CheckboxButton;